import { render } from "./SearchList.vue?vue&type=template&id=31f2c2bb&scoped=true&ts=true"
import script from "./SearchList.vue?vue&type=script&lang=ts"
export * from "./SearchList.vue?vue&type=script&lang=ts"

import "./SearchList.vue?vue&type=style&index=0&id=31f2c2bb&lang=scss&scoped=true"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f2c2bb"]])

export default __exports__